import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryRoomMatrixData = Content.Components['RoomMatrixModuleDto'];

interface UseQueryRoomMatrixOptions {
  enabled?: boolean;
  initialData?: UseQueryRoomMatrixData;
  parameters?: Content.Components['IHotelPageHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQueryRoomMatrix = ({
  enabled = true,
  initialData,
  parameters,
}: UseQueryRoomMatrixOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryRoomMatrixData>(
    [QueryId.ROOM_MATRIX, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/room-matrix';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryRoomMatrix', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryRoomMatrix;
